import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import { Checkbox } from '@els/els-react--checkbox';

import './GroupCheckboxes.scss';

export function GroupCheckboxes(props) {
  const { id, option, groupId, optionId, onCheckboxClick, disableIncludeAndMoreGroup } = props;
  const title = option.get('title');
  const checked = option.get('checked') || false;

  return (
    <Checkbox
      data-e2e={`group-checkbox-${optionId}`}
      className="group-checkboxes-checkbox"
      disabled={disableIncludeAndMoreGroup}
      checked={checked}
      onChange={() => {
        onCheckboxClick(id, groupId, optionId);
      }}
      label={title}
    />
  );
}

GroupCheckboxes.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map).isRequired,
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};

export default function GroupCheckboxesList(props) {
  const { group } = props;
  const optionsIds = group.get('optionsIds');
  const options = group.get('options');

  return (
    <>
      {optionsIds.map((id) => (
        <GroupCheckboxes {...props} key={id} optionId={id} option={options.get(id)} />
      ))}
    </>
  );
}

GroupCheckboxesList.propTypes = {
  group: PropTypes.instanceOf(Map).isRequired,
};
